module.exports = __webpack_public_path__ + "img/radio-negeri-sembilan.d75a96b1.jpg";